export const changeChannelSelection = (
  selectedChannelIds: string[],
  channelId: string,
  selected: boolean
): string[] => {
  if (selected) {
    return selectedChannelIds.includes(channelId)
      ? selectedChannelIds
      : [...selectedChannelIds, channelId];
  }

  return selectedChannelIds.filter((id) => id !== channelId);
};
